import React from 'react'
import ReactDOM from 'react-dom/client'
import { MemoryRouter, Route, Routes } from 'react-router-dom'
import { initializeIcons, ThemeProvider } from '@fluentui/react'

import Layout from './pages/layout/Layout'
import { AppStateProvider } from './state/AppProvider'
import TalkingHeadProvider from './state/TalkingHeadProvider'
import { leobitTheme } from './utils/themes';

import './index.css'
import { SwitchPage } from './components/switchPage/SwitchPage'
import { captureTrafficSource } from './utils/trafficSource'

captureTrafficSource()

initializeIcons(
  'https://res.cdn.office.net/files/fabric-cdn-prod_20240129.001/assets/icons/',
)

export default function App() {
  return (
    <AppStateProvider>
      <TalkingHeadProvider>
        <ThemeProvider applyTo="body" theme={leobitTheme} style={{ height: '100%' }}>
          <MemoryRouter>
            <Routes>
              <Route path="/" element={<Layout />}>
                <Route index element={<SwitchPage />} />
              </Route>
            </Routes>
          </MemoryRouter>
        </ThemeProvider>
      </TalkingHeadProvider>
    </AppStateProvider>
  )
}

ReactDOM.createRoot(document.getElementById('leora-widget-root') as HTMLElement).render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
)
